import React, { useState } from "react";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";
import toast from "react-hot-toast";

const DeleteBooking = ({ isOpen, onClose, booking_id, fetchPlayers }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleDeleteBooking = async () => {
        setIsSubmitting(true);
        try {
            const response = await apiService.delete(`/bookings/${booking_id}`); // API call to delete booking
            onClose();
            toast.success(response.message, { duration: 2000, });

            fetchPlayers(); // Refresh bookings list after deletion
        } catch (errors) {
            handleError(errors);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
            <div className="bg-white rounded-lg p-6 w-[310px] sm:w-[350px] h-auto shadow-lg relative">
                <p className="text-lg font-semibold mb-8 text-center">
                    Are you sure you want to delete this booking?
                </p>
                <div className="flex justify-center gap-4 mt-4">
                    <button
                        className="w-[75px] sm:w-[93px] py-2 text-center text-sm bg-white text-green rounded-lg border border-green"
                        onClick={onClose}
                    >
                        Close
                    </button>
                    <button
                        type="submit"
                        className={`w-[75px] sm:w-[93px] text-sm text-center py-2 rounded-lg ${isSubmitting ? "bg-green50 cursor-not-allowed" : "bg-green text-white"
                            }`}
                        disabled={isSubmitting}
                        onClick={handleDeleteBooking}
                    >
                        {isSubmitting ? "Deleting..." : "Confirm"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteBooking;
